import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import React from 'react'
import { BsBellFill } from 'react-icons/bs';
import style from './style.module.css';
import profilePic from '../../img/profile_pics.svg';

function Header() {
    return (
        <Flex className={style.header_container} padding="10px 35px" justifyContent="space-between" as="header">
            <Flex flexDirection="column" >
                <Text as="h2" fontSize="22px" className={style.header_username} fontWeight="bold">Hello Daniel,</Text>
                <Text as="p" fontSize="18px" className={style.header_greetings}>How is your day going?</Text>
            </Flex>

            <Flex alignItems="center">
                <Box position="relative" mr="15px">
                   <Icon color="secondary.nav_gray" fontSize="32px" as={BsBellFill}/>
                   <span className={style.is_notification_dot}></span>
                </Box>

                <img className={style.nav_profile_img} src={profilePic} alt="profile pics"/>
            </Flex>
        </Flex>
    )
}

export default Header;
